<template>
  <div class="container">
    <p>
      PT CAR SOME INDONESIA (disebut juga sebagai "Pengelola") ingin mengucapkan
      terima kasih telah mempercayakan penjualan mobil anda di Carsome
      Indonesia. Sebelum anda mengirimkan data-data mobil anda kepada kami, kami
      ingin anda membaca dan menyetujui Syarat-syarat dan Ketentuan-ketentuan
      dibawah ini:
    </p>
    <p></p>
    <h2>Syarat dan Ketentuan (Terms and Conditions)</h2>
    <p>
      Saya, (disebut juga sebagai "Pengguna") dengan ini setuju untuk memberikan
      Pengelola dan/atau pihak terkait lainnya ijin untuk menggunakan data-data
      saya seperti: nama, kontak, alamat email, dan lain-lain (selanjutnya
      disebut juga "Data Pribadi") dengan ketentuan yang akan disebutkan dibawah
      ini:
    </p>
    <p>
      Data Pribadi akan digunakan oleh Pengelola guna menghubungkan Pengguna
      dengan dealer-dealer mobil rekanan Pengelola melalui media komunikasi
      seperti: email, surat tercatat, SMS dan/atau telepon.
    </p>
    <p>
      Tidak menutup kemungkinan Pengelola akan menggunakan jasa dari pihak
      ketiga untuk memprosesi Data Pribadi milik para Pengguna tersebut. Perlu
      diketahui juga bahwa pihak ketiga yang dimaksud wajib memenuhi peraturan
      yang telah dituangkan ke dalam kontrak dengan Pengelola dimana penggunaan
      Data Pribadi dari Pengguna tidak akan digunakan disalahgunakan untuk
      hal-hal lain selain yang tertuang di dalam kotrak tersebut.
    </p>
    <p>Pengguna mempunyai hak dan wewenang dari waktu ke waktu untuk:</p>
    <ul>
      <li><p>1.&nbsp;&nbsp;&nbsp;Mencabut ijin penggunaan Data Pribadi;</p></li>
      <li>
        <p>
          2.&nbsp;&nbsp;&nbsp;Meminta perubahan dan/atau pengkinian atas Data
          Pribadi;
        </p>
      </li>
      <li>
        <p>
          3.&nbsp;&nbsp;&nbsp;Menanyakan hal-hal sehubungan penggunaan Data
          Pribadi-nya
        </p>
      </li>
    </ul>
    <p>
      - dengan menghubungi Pengelola di:
      <a href="mailto:andreas@carsome.id" target="_blank">andreas@carsome.id</a>
    </p>
    <p>&nbsp;</p>
    <p>
      Pengelola wajib mengambil langkah-langkah yang terbaik untuk menjaga
      keutuhan dan keamanan Data Pribadi dari Pengguna, dan juga meminta kepada
      pihak ketiga untuk menjaga kepentingan tersebut.
    </p>
    <p>
      Pengelola dengan ini juga memberikan jaminan kepada Pengguna bahwa Data
      Pribadi akan dihilangkan atau dihapus secara permanen apabila tidak lagi
      dibutuhkan oleh Pengelola.
    </p>
    <p>
      Pengelola akan mengikuti regulasi serta peraturan perundang-undangan yang
      berlaku dalam menjaga keutuhan Data Pribadi, akan tetapi apabila regulasi
      dan peraturan perundang-undangan tersebut mewajibkan Pengelola untuk
      memberikan Data Pribadi kepada pihak yang berwenang, maka Pengelola akan
      memberikan Data Pribadi tersebut sesuai dengan permintaan dari pihak yang
      berwenang tersebut.
    </p>
    <p>
      Untuk mengakses Kebijakan Privasi kami, anda dapat mengunjungi laman
      wesbite kami di&nbsp;<a
        href="https://carsome.id/kebijakan-privasi"
        target="_blank"
        ><b>https://carsome.id/kebijakan-privasi</b></a
      ><b>.</b>
    </p>
  </div>
</template>


<style scoped>
.container {
  padding: 24px 16px 16px 16px;
  width: 100%;
  box-sizing: border-box;
}

p {
  margin-top: 8px;
  text-align: start;
  font-size: 14px;
  font-weight: 400;
  font-family: Roboto;
  font-style: normal;
  color: #696c71;
}

h2 {
  text-align: start;
  font-size: 14px;
  font-weight: 500;
  font-family: Roboto;
  font-style: normal;
  color: #2e2e2e;
  margin-top: 24px;
  font-weight: 700;
}

ul {
  padding-left: 12px;
}
</style>
